if (!process.env.NEXT_PUBLIC_LUMNIPORTAL_WEB_BASE_URL) {
  throw new Error(`Env var NEXT_PUBLIC_LUMNIPORTAL_WEB_BASE_URL is missing`);
}

export const lumniPortalWebBaseUrl = process.env.NEXT_PUBLIC_LUMNIPORTAL_WEB_BASE_URL;

const lumniPortalNavigation = {
  lostPaswordRecovery: new URL("users/password/new", lumniPortalWebBaseUrl).toString(),
};

export default lumniPortalNavigation;
